module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/hero-image-7bc77e75778ad88efb2904244986f100.webp";